{
  "hero": {
    "title": "使用條款",
    "description": "說明使用 NAPAICP 競賽平台帳號時應遵守的基本規範。個別競賽可能另有主辦方公告的補充規則，以該場競賽公告為準。"
  },
  "quickNav": {
    "label": "頁內導覽",
    "account": "帳號使用",
    "conduct": "行為規範",
    "content": "作品與內容",
    "availability": "服務可用性",
    "changes": "條款修訂",
    "related": "相關頁面"
  },
  "account": {
    "heading": "帳號使用",
    "items": {
      "accurate": "註冊時提供的姓名、Email 與單位資訊應真實且為使用者本人所有，不得冒用他人身分註冊。",
      "credentials": "使用者須妥善保管自己的登入密碼，平台管理員不會、也無法讀取或設定使用者的永久密碼。",
      "oneAccount": "同一使用者原則上使用單一帳號參與平台上的競賽；以多重帳號規避競賽規則（例如隊伍人數限制）視為違反本條款。"
    }
  },
  "conduct": {
    "heading": "行為規範",
    "description": "使用平台時，不得：",
    "items": {
      "impersonate": "冒用他人身分、偽造報名或評審資料",
      "unauthorized": "嘗試繞過權限控制存取不屬於自己的競賽、作品或評分資料",
      "abuse": "以自動化方式大量嘗試登入、濫用邀請連結或干擾平台正常運作",
      "share": "在未經允許的情況下下載、轉傳或公開他人未公開的作品內容",
      "shuttle": "使用活動接駁車預約時，以虛假姓名預約、轉傳或販售乘車 QR、或以多個 Email 規避每人每日每方向一筆的限制"
    }
  },
  "content": {
    "heading": "作品與內容",
    "description": "參賽作品的著作權歸屬與使用範圍，請見資料保存政策頁面的「作品權利」章節。使用者提交的所有內容（包含報名資料、作品檔案與表單答案）應合法取得使用授權，不得侵害第三方權利。"
  },
  "availability": {
    "heading": "服務可用性",
    "description": "平台會採取合理措施維持服務穩定，但不保證絕對不中斷。若投稿截止時間前發生重大平台故障，管理員可依具稽核紀錄的程序延長該場競賽的截止時間，詳見 Trust Center。"
  },
  "changes": {
    "heading": "條款修訂",
    "description": "本條款可能隨平台功能演進而更新；重大變更將於本頁面公告。持續使用平台視為同意最新版本的條款。"
  },
  "related": {
    "heading": "相關頁面",
    "privacy": "隱私權說明",
    "dataPolicy": "資料保存政策",
    "trust": "Trust Center",
    "contact": "如對本條款有疑問，請寄信至"
  }
}
